import React from 'react';
import { ITrip } from '../interfaces/trips/ITrips';

interface TripSelectionProps {
  trips: ITrip[];
  onTripSelect: (tripId: string) => void;
}

const TripSelection: React.FC<TripSelectionProps> = ({ trips, onTripSelect }) => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
          What trip are you working on?
        </h1>
        
        <div className="space-y-6">
          {trips.map((trip) => (
            <div key={trip.id} className="bg-gray-100 rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="mb-4">
                <h2 className="text-xl font-bold text-gray-900 mb-2">
                  {trip.name}
                </h2>
                <p className="text-gray-600 text-sm">
                  {trip.route}
                </p>
				<p className="text-gray-600 text-sm">
                  Assign on cabins: {trip.assignedCabins.join(', ')}
                </p>
				<p className="text-gray-600 text-sm">
                  {trip.locations.join('-')}
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-md p-4 mb-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.25A1 1 0 009 15.25v-3.5a1 1 0 00-1-1h-3a1 1 0 00-1 1v3.5a1 1 0 00.894 1.409l5 1.25a1 1 0 001.169-1.409l-7-14z" />
                    </svg>
                    <span className="text-sm text-gray-700">{trip.type}</span>
                  </div>
                  
                  <div className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-gray-700">{trip.duration}</span>
                  </div>
                  
                  <div className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-gray-700">ID: {trip.id}</span>
                  </div>
                  
                  <div className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <span className="text-sm text-gray-700">{trip.direction}</span>
                  </div>
                </div>
              </div>
              
              <button
                onClick={() => onTripSelect(trip.id)}
                className="w-full bg-gray-800 text-white py-3 px-4 rounded-md hover:bg-gray-700 transition-colors duration-200 font-medium"
              >
                Log into this trip
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TripSelection; 